<template>
    <div>
        <h5>{{ $t('account.delete_account') }}</h5>

        <p>{{ $t('account.delete_account_description') }}</p>

        <button class="btn btn-danger btn-sm" @click="showAccountConfirmModal = true">{{ $t('account.delete_account_button') }}</button>

        <AccountConfirmModal
            v-if="showAccountConfirmModal"
            @confirmed="confirm"
            @close="showAccountConfirmModal = false"
            :error-message="errorMessage"
        />
    </div>
</template>

<script setup>
    import AccountConfirmModal from '../components/AccountConfirmModal.vue';
    import { inject, ref } from 'vue';
    import { AccountService } from '../services/accountService';
    import i18n from '../utils/locale';
    import { notifyError } from '../utils/notify';
    import { useRouter } from 'vue-router/composables';

    const emit = defineEmits(['loading', 'deleted']);

    const router = useRouter();
    const store = inject('store');

    const showAccountConfirmModal = ref(false);

    const errorMessage = ref(null);

    async function confirm(token) {
        errorMessage.value = null;
        emit('loading', true);

        try {
            await AccountService.getInstance().deleteAccount(token);
            emit('deleted');
        } catch (exception) {
            errorMessage.value = exception?.response?.data?.message || i18n.t('general.something_went_wrong');
            notifyError(exception);
        } finally {
            emit('loading', false);
        }
    }
</script>
